import { useEffect, useState } from "react";
import UserCircleIcon from "src/svgComponents/DashboardCardIcons/UesrCircle";
import SubAdminIcon from "src/svgComponents/DashboardCardIcons/SubAdmin"
import ResturantIcon from "@mui/icons-material/Restaurant";
import ShopIcon from "@mui/icons-material/LocalGroceryStore";
import EventIcon from "@mui/icons-material/Event";
import TravelIcon from "@mui/icons-material/ConnectingAirports";
import NGOIcon from "@mui/icons-material/Support";
import LoadingScreen from 'src/components/LoadingScreen'
import { useQuery } from 'react-query';
import { TRACE_API_URL, USER_API_URL, BUSINESS_API_URL } from "src/api/axios";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import { useNavigate } from "react-router";
import RevenueChart from "./charts/RevenueChart"
import RevenueBarChart from "./charts/RevenueBarChart"
import EarningChart from "./charts/Earning"
import { Stack } from "@mui/material";
import { carbonEmmision as reventChartData } from '../dashboard/charts/DataVisualization'
import PlacedOrderList from "./placedOrder"
const Dashboard = () => {
   const axiosPrivate = useAxiosPrivate();
   const [loding, setLoding] = useState(true);
   const navigate = useNavigate();

   const { data: DashboardData, refetch } = useQuery(
      "DashboardData",
      async ({ signal }) => {
         // setLoding(false)
         return await axiosPrivate
            .get(USER_API_URL.dashboard, { signal })
            .then((res) => res.data)
            .catch((e) => { console.log(e) });
      },
      { refetchOnWindowFocus: false }
   );
   // const { data: chart_data } = useQuery(
   //    "earningChartData",
   //    async ({ signal }) => {
   //       return await axiosPrivate
   //          .get(USER_API_URL.chartData, { signal })
   //          .then((res) =>
   //              res.data
   //          )
   //          .catch((e) => { console.log(e) });
   //    },
   //    { refetchOnWindowFocus: false }
   // );
   // const earningChartData = chart_data?.earning_chart;
   // const revenueBarChartData = chart_data?.revenueBarChartData;
   // const revenueChartData = chart_data?.revenueChartData;
   useEffect(() => {
      setTimeout(() => {
         setLoding(false);
      }, 300);
   }, [DashboardData/* ,earningChartData,revenueBarChartData,revenueChartData */])
   const formatCount = (count) => {
      // function done by shreya
      const COUNT_ABBRS = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
      const decimals = 2;
   
      const i = 0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));
      let result= parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
      // if (withAbbr) {
      result += `${COUNT_ABBRS[i]}`;
      // }
      let value = count;
      if (count >= 1000) {
         value = result;
      }
      return value;
   };
   return (
      <>
         {loding ? <LoadingScreen /> : <>
            <h4 className="app_text_20_semibold">Dashboard</h4>
            <div className="container-fluid mt-4 px-0">
               <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4 g-4">
                  <div className="col">
                     <div className="card text-center dashboard_card">
                        <div className="justify-content-evenly card-header">
                           Restaurant
                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.Restaurant ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Total User</span>
                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.TodayRestaurant ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Today User</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Grocery Shops
                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.Shops ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Total User</span>

                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.TodayShops ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Today User</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Event Planner
                        </div>
                        <div className="card_content">

                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.Events ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Total User</span>

                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.TodayEvents ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Today User</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Charity NGO
                        </div>
                        <div className="card_content">

                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.NGO ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Total User</span>

                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.TodayNGO ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Today User</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Restaurant Orders
                        </div>
                        <div className="card_content">

                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.RestaurantOrder ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">No Of Orders</span>

                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.RestaurantOrderToday ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Today Orders</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Grocery Orders
                        </div>
                        <div className="card_content">

                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.ShopOrder ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">No Of Orders</span>

                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.ShopOrderToday ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Today Orders</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Event Planner
                        </div>
                        <div className="card_content">

                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.EvenBooking ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">No Of Orders</span>

                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.EvenBookingToday ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Today Orders</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Charity NGO 
                        </div>
                        <div className="card_content">

                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.NgoDonation ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">No Of Orders</span>

                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.NgoDonationToday ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Today Orders</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Restaurant 
                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.TotalDishes ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Total Dishes</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
              
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Grocery Shops 
                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.TotalGrocery ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Total Grocery</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Event Planner 
                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.TotalEvents ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Total Events</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Charity NGO 
                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{DashboardData?.TotalCharity ?? 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Total Charity Items</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
     
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Restaurant Payout
                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.RestaurantPayout?.pending) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Pending</span>
                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.RestaurantPayout?.inprogress) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">In Progress</span>
                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.RestaurantPayout?.confrim) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Confirmed</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Grocery Shop Payout

                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.ShopPayout?.pending) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Pending</span>
                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.ShopPayout?.inprogress) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">In Progress</span>
                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.ShopPayout?.confrim) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Confirmed</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Event Planner Payout
                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.EventPayout?.pending) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Pending</span>
                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.EventPayout?.inprogress) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">In Progress</span>
                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.EventPayout?.confrim) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Confirmed</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="card text-center  dashboard_card">
                        <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                           Charity NGO Payout
                        </div>
                        <div className="card_content">
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.NgoPayout?.pending) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Pending</span>
                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.NgoPayout?.inprogress) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">In Progress</span>
                           </Stack>
                           <Stack spacing={2}>
                              <span className="app_text_12_fw500 app_text_black_3">{formatCount(DashboardData?.NgoPayout?.confrim) || 0}</span>
                              <span className="d-flex app_text_14_500 app_text_gray">Confirmed</span>
                           </Stack>
                        </div>
                     </div>
                  </div>
              
                  
               </div>
               <div className="row g-5 mt-5 dashboard_chart_container">
                  {/* <div className="col col-xl-7 col-xxl-6">
                     <RevenueChart data={revenueChartData}/>
                  </div>  */}
                   <div className="col col-xl-5 col-xxl-6">
                     {/* <RevenueBarChart data={revenueBarChartData && revenueBarChartData}/> */}
                  </div>
                  <div className="col col-xl-6 col-xxl-6">
                     {/* <EarningChart data={earningChartData && earningChartData}/> */}
                  </div>
               </div>
                  <PlacedOrderList />
            </div>

         </>
         }
      </>
   )
}

export default Dashboard